export default "__VITE_ASSET__DoQqom7k__"